module.exports = __webpack_public_path__ + "static/media/business-hero.3fd8d527.png";